import {Dispatch, MutableRefObject, SetStateAction, useEffect, useRef, useState} from "react";

export function useStateRef<S>(initialValue: S | (() => S)): [S, Dispatch<SetStateAction<S>>, MutableRefObject<S>] {
  const [value, setValue] = useState(initialValue);

  const ref = useRef(value);

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return [value, setValue, ref];
}